import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "./AppContext";
import { getConfigValue } from "./getConfigValue";

export function useRoutingValidation() {
    const [appState] = useContext(AppContext);
    const salesAidGenerationEnabled = !appState.configLoaded ? false : getConfigValue(appState?.config?.Sellsheet?.Generation?.Enabled, appState)?.Value === 'true' || false;

    const navigate = useNavigate();
    useEffect(() => {
        if (!salesAidGenerationEnabled) {
            navigate('/');
        }
    }, [])

    return true;
}